<template>
        <div class='homeLanding'>
            <div class="row homeMigrationNotice">
                <div class="col">
                    <p><strong>Your Customer Portal Is Moving</strong></p>
                    <p>We’re transitioning from the Pawnee customer portal to the NMEF customer portal. The current portal will automatically redirect you to the new site, where you’ll need to create a new login to access your account.</p>
                    <p>To get started, visit the <a href="https://customer.nmef.com/?brand=pawnee" target="_blank">NMEF Customer Portal</a>, click “Enroll Now,” and register using your SSN or EIN. Please use the email address on file with your existing account to receive the verification code needed to complete setup.</p>
                    <p>We’re here to help make this transition as smooth as possible. Please contact our team at <a href="mailto:Portal@nmef.com">Portal@nmef.com</a> with any questions or for assistance enrolling.</p>
                </div>
            </div>
            <div class="row homeLandingText">
                <div class="col">
                    <div><p><strong>Experts in Commercial Equipment Finance Since 1982</strong></p></div>
                    <div><h1>Helping your Business Achieve New Heights</h1></div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style>
.homeLanding {
    position: relative;
    margin: 0 -15px;
    min-height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
    padding-bottom: 76px;
}
.homeLanding::before {
    content: '';
    width: 100%;
    height: 100%;
    background-image: url(/static/pawnee-portal-landing-2.jpg);
    background-repeat: no-repeat;
    left: 0;
    top: 0px;
    background-size: cover;
    background-position: center;
    position: fixed;
    z-index: -1;
}
.homeLandingText {
    width: 100%;
    margin: auto 0 0 0;
    flex-shrink: 0;
    text-align: center;
    padding: 20px 0 20px 0;
    background-color: rgba(255,255,255,0.6);
}
.homeLandingText p {
    font-size: 1.2em;
}
.homeMigrationNotice {
    width: 100%;
    margin: 40px 0 10px 0;
    flex-shrink: 0;
    text-align: center;
    padding: 20px 10% 10px 10%;
    background-color: rgba(255,255,255,0.85);
}
.homeMigrationNotice p {
    font-size: 1.1em;
}
.homeLandingText h1 {
    font-size: 3em;
}
.homeLandingCoronaText {
    bottom: 120px;
    width: 100%;
    margin: auto;
    text-align: center;
    position: absolute;
    padding: 20px 0 20px 0;
    background-color: rgba(255,255,255,0.6);
}
.coronaSecondPass {
    height: 10em;
    position: relative;
    background-color: rgba(252,240,212,0.8);
}
.coronaSecondPass p {
    color: black;
    font-size: large;
    top: 50%;
    left: 50%;
    position: absolute;
    padding: 50px;
    margin-right: -50%;
    transform: translate(-50%, -50%);
}
body {
  display: grid;
  margin: 0;
}

@media screen and (max-width: 680px) {
    .homeLanding::before {
    background-image: url(/static/pawnee-portal-landing_mobile.jpg);
    }
    .homeMigrationNotice {
    margin-top: 10px;
    padding: 10px 15px 0 15px;
    }
    .homeMigrationNotice p {
    font-size: 0.85em;
    }
}
</style>



// WEBPACK FOOTER //
// src/home.vue